import React from 'react';
export var Star = function Star(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1L7.12257 4.45492H10.7553L7.81636 6.59017L8.93893 10.0451L6 7.90983L3.06107 10.0451L4.18364 6.59017L1.24472 4.45492H4.87743L6 1Z",
    strokeLinejoin: "round",
    stroke: "inherit",
    fill: props.fill ? 'inherit' : 'none'
  }));
};